import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import serviceHubDetailsQueryParameters from '@atlassian/jira-customer-service-service-hub-details/src/ui/__generated__/ServiceHubDetailsPageQuery$parameters';
import hubSetupQueryParameters from '@atlassian/jira-customer-service-service-hub-details/src/ui/hub-setup/__generated__/HubSetupQuery$parameters';
import { fg } from '@atlassian/jira-feature-gating';

export const helpCenterSettingDetailsAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-help-center-setting-details-app" */ './src/ui'),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			serviceHubDetailsQuery: {
				parameters: serviceHubDetailsQueryParameters,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
			...(fg('csm-onboarding')
				? {
						hubSetupQuery: {
							parameters: hubSetupQueryParameters,
							variables: {
								helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
							},
							options: {
								fetchPolicy: 'store-and-network' as const,
							},
						},
					}
				: {}),
		},
	}),
});
